export default __webpack_public_path__ + "static/media/female-img.4e162a83.png";